import React, { useEffect } from 'react';
import { Box, Flex, Spinner } from '@chakra-ui/react';

import { TextBold, TextRegular } from 'UiKit/typography';
import { Condition } from 'Component/others';
import { useToast } from 'Store/toast';
import { CloseIcon } from 'Asset/icon';

import { getColor } from './const';
import styles from './styles.module.css';

const Toast = () => {
  const { status, type = 'desktop', title, description, duration = 2, onResetToast, alwaysShow, position } = useToast();

  const { borderColor, backgroundColor, icon, textColor } = getColor({ status });

  useEffect(() => {
    setTimeout(() => {
      if (status && status !== 'loading' && !alwaysShow) {
        onResetToast();
      }
    }, [duration * 1000]);
    // eslint-disable-next-line
  }, [status, title, description, alwaysShow]);

  return (
    <Condition statement={!!status}>
      <Box className={`${styles['toast__container']} ${styles[`toast__container--${position}`]}`}>
        <Flex
          className={`${styles[`toast__box--${type}`]}`}
          bg={backgroundColor}
          {...(type === 'desktop' ? { borderLeft: `1px solid ${borderColor}` } : { border: `1px solid ${borderColor}` })}
        >
          <Box className={styles['icon__container']}>{icon}</Box>
          <Box className={styles['info__container']}>
            <TextBold className={styles['toast__title']} color={textColor}>
              {title}
            </TextBold>
            <TextRegular className={styles['toast__description']} color={textColor}>
              {description}
            </TextRegular>
          </Box>

          <Condition statement={status !== 'loading'} fallback={<Spinner size="md" color="var(--color-info60)" margin="auto 0" />}>
            <CloseIcon size="18px" color={borderColor} onClick={onResetToast} />
          </Condition>
        </Flex>
      </Box>
    </Condition>
  );
};

export default Toast;
